


































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserStatus } from 'admiral-core';

@Component({
  components: {},
})
export default class UserStatusBadge extends Vue {
  @Prop({ required: true, type: Number })
  status!: UserStatus;

  get getStatus() {
    return UserStatus;
  }
}
